import useApiQuery from 'shared/hooks/use-api-query';
import {AddressProps} from '../types';
import useQueryHelpers from 'shared/hooks/use-query-helpers';
import neighborhoodsKeys from 'modules/neighborhoods/util/neighborhoods-keys';
import {CityProps} from 'modules/cities/types';
import {NeighborhoodProps} from 'modules/neighborhoods/types';

const useCoordinatesByAddress = (address?: AddressProps) => {
  const {getData} = useQueryHelpers();

  const cities = getData<CityProps[]>('/cities/all') ?? [];
  const neighborhoods =
    getData<NeighborhoodProps[]>(
      neighborhoodsKeys.cities((address ?? {}).cityId!),
    ) ?? [];

  const formatAddress = (address?: AddressProps) => {
    if (!address) return '';
    const {street, cityId, neighborhoodId, state, number} = address;

    const city = cities.find((city) => city.id === cityId)?.name;
    const neighborhood = neighborhoods.find(
      (neighborhood) => neighborhood.id === neighborhoodId,
    )?.name;

    return `${street}, ${number}, ${neighborhood}, ${city}, ${state}`;
  };

  const {data = [], ...query} = useApiQuery<AddressProps[]>({
    url: `/addresses/forward-geocoding?address=${formatAddress(address!)}`,
    enabled: !!address,
  });

  return {...query, data: data[0]};
};

export default useCoordinatesByAddress;
